// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".game-report-gallery[data-v-c3aa3a90]{background-color:var(--light-color);margin-top:1rem;padding:1.5rem 1.5rem .5rem 1.5rem}.game-report-gallery[data-v-c3aa3a90] .swiper .swiper-slide{height:240px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
